// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_alert__qmAaW {
	position: fixed;
	top: 0;
	left: 5%;
	right: 5%;
	margin: auto;
	width: fit-content;
	text-align: center;
	padding: 0 30px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 3;
	border-radius: 2px;
	font-size: 15px;
}

.style_success__iZYOS {
	color: #fff;
	background-color: seagreen;
}

.style_error__tLX\\+O {
	background-color: #feebea;
	color: var(--alerts-red);
}`, "",{"version":3,"sources":["webpack://./src/components/alert/style.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,MAAM;CACN,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,UAAU;CACV,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;CACzB,wBAAwB;AACzB","sourcesContent":[".alert {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 5%;\n\tright: 5%;\n\tmargin: auto;\n\twidth: fit-content;\n\ttext-align: center;\n\tpadding: 0 30px;\n\theight: 50px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 3;\n\tborder-radius: 2px;\n\tfont-size: 15px;\n}\n\n.success {\n\tcolor: #fff;\n\tbackground-color: seagreen;\n}\n\n.error {\n\tbackground-color: #feebea;\n\tcolor: var(--alerts-red);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `style_alert__qmAaW`,
	"success": `style_success__iZYOS`,
	"error": `style_error__tLX+O`
};
export default ___CSS_LOADER_EXPORT___;
